// ---------------------------------------------------------------------------
// Fallback + capping
// ---------------------------------------------------------------------------
//
// Minimal stock-math helpers shared across basket and product utilities.
// Fallback caps the quantity a line is allowed to grow to when the API
// hasn't given us an explicit per-branch / per-product max. The `capStock`
// wrapper is the single place that turns "raw value from the API" into
// "what we actually let the UI show".

/** Returns the default max quantity fallback based on product type. */
export const getMaxQtyFallback = (productType?: string): number =>
  productType === 'consumable' ? 1000 : 10

/** Caps a stock value to the fallback, returning the fallback if stock is missing/invalid. */
export const capStock = (
  stock: number | null | undefined,
  fallback: number
): number => {
  const n = Number(stock)

  return Number.isFinite(n) && n > 0 ? Math.min(n, fallback) : fallback
}
